module.exports = __webpack_public_path__ + "static/media/indan-man-house.00470f22.svg";